// Empty string is the "no selection" sentinel — real domain values (UUIDs,
// enum numbers, "active"/"inactive") never round-trip to '' from the picker.
export const KEEP_AS_IS = ''

export const LABELS = {
  keepAsIs: 'Keep as is',
  primaryButton: 'Update',
  cantBeUndone: "Can't be undone after saving",
  commentLabel: 'Add a comment',
  commentPlaceholder: 'Visible in activity log for audit purposes',
}
